<div class="modal-header">
  <h4 class="modal-title">Задаване на парола</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="loading"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <div class="alert alert-warning">
    <h6>Добре дошли! Това е Вашето първо влизане. Необходимо е да зададете парола.</h6>
    Електронната поща <strong>{{ emailInput }}</strong> не е регистрирана в платформата. За да получите пълен достъп,
    включително участие в наддавания
    и извършване на покупки, моля, задайте парола, която ще използвате за достъп до системата, когато това е необходимо.
  </div>
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <label for="username" class="mb-0 form-label">Потребителско име*</label>
      <button
        type="button"
        (click)="showUsernameInfo()"
        class="btn btn-link text-dark p-0">
        <i class="mx-1 text-primary-emphasis fa-regular fa-circle-question" aria-hidden="true"></i>
      </button>
      <input
        id="username"
        type="text"
        formControlName="username"
        class="form-control"
        placeholder="Въведете потребителско име..."
        aria-label="Потребителско име"
        [class.is-valid]="username?.touched && username?.valid"
        [class.is-invalid]="username?.touched && username?.invalid">
      <p class="invalid-feedback m-0">Задължително поле!</p>
    </fieldset>
    <fieldset class="mb-4">
      <label for="password" class="mb-0 form-label">Парола*</label>
      <input
        id="password"
        type="password"
        minlength="8"
        formControlName="password"
        class="form-control"
        placeholder="Въведете парола..."
        aria-label="Парола"
        [class.is-valid]="password?.touched && password?.valid"
        [class.is-invalid]="password?.touched && password?.invalid">
      <p class="invalid-feedback m-0">Задължително поле с минимална дължина от 8 символа!</p>
    </fieldset>
    <fieldset class="mb-4">
      <label for="confirmPassword" class="mb-0 form-label">Повторете паролата*</label>
      <input
        id="confirmPassword"
        type="password"
        minlength="8"
        formControlName="confirmPassword"
        class="form-control"
        placeholder="Повторете паролата..."
        aria-label="Повторете паролата"
        [class.is-valid]="confirmPassword?.touched && confirmPassword?.valid && confirmPassword?.value === password?.value"
        [class.is-invalid]="confirmPassword?.touched && (confirmPassword?.invalid || confirmPassword?.value !== password?.value)">
      @if (confirmPassword?.touched && !confirmPassword?.valid) {
        <div class="text-danger">
          <small>Задължително поле с минимална дължина от 8 символа!</small>
        </div>
      }
      @if (confirmPassword?.touched && confirmPassword?.value !== password?.value) {
        <div class="text-danger">
          <small>Паролата не съвпада!</small>
        </div>
      }
    </fieldset>
    <fieldset class="mb-4">
      <div class="d-flex align-items-start">
        <input
          type="checkbox"
          class="form-check-input"
          id="isConfirmTermsConditions"
          formControlName="isConfirmTermsConditions">
        <p class="invalid-feedback m-0">Задължително поле (от 2 до 50 символа)!</p>
        <label for="isConfirmTermsConditions" class="mx-2 form-check-label">
          Декларирам, че съм запознат и приемам
          <a class="text-decoration-none"
             aria-label="Общи условия на сайта"
             [routerLink]="[appRoutes.root, appRoutes.termsConditions]">
            общите условия на сайта.
          </a>
        </label>
      </div>
      @if (isConfirmTermsConditions?.touched && !isConfirmTermsConditions?.value) {
        <div class="text-danger">
          <small>Трябва да се запознаете и да приемете общите условия!</small>
        </div>
      }
    </fieldset>
  </form>
  @if (!!errorMessage) {
    <div class="mt-3 text-danger">
      {{ errorMessage }}
    </div>
  }
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
